<template>
  <div class="hero-container">
    <div src="http://localhost:8000/build/images/evgeshayoga_landscape.webp" class="yoga-header"/>
    <div class="yoga-header-text-block">
      <div class="title-blog">
        <h1 class="title is-1">ЙОГА С ЖЕНЕЙ</h1>
        <p class="lead">Свобода в движении</p>
      </div>
    </div>
    <div class="yoga-header-buttons-block-wrapper">
      <div class="is-flex is-justify-content-space-between yoga-header-buttons-block">
        <a href="/yoga-online" class="button is-medium is-primary mt-4 animated-gradient-button">Йога online</a>
        <a href="/marathons" class="button is-medium is-primary mt-4 animated-gradient-button">Курсы</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Hero',
}
</script>

<style>

.hero-container {
  position: relative;
  width: 100%;
}
</style>
